export const workflowEn = {
  workflowsInBoard: 'Workflows in board',
  empty: 'No workflows in this board yet',
  workflows: 'Workflows',
  actionDone: 'The action was completed successfully',
  actionError: 'An error occurred, please try again later',
  notFound: 'Workflow not found',
  moveDisallowed: 'Moving is disabled because of workflow in this board',
  stagesUndefined: 'Stages must be defined in workflow',
  failedToSave: 'Failed to save the workflow, please check format',
  workflowDefaultName: 'Workflow',
  nextStageAction: 'Next stage',
  create: 'Create task',
  errorInLine: (lineNum: number) => `Error in line number ${lineNum}`
}

export const workflowRu: typeof workflowEn = {
  workflowsInBoard: 'Процессы в доске',
  empty: 'В этой доске ещё нет настроенных процессов',
  workflows: 'Процессы',
  actionDone: 'Действие выполнено успешно',
  actionError: 'Произошла ошибка, попробуйте позже',
  notFound: 'Процесс не найден',
  moveDisallowed:
    'Перемещение задачи запрещено из-за настроенного процесса в доске',
  stagesUndefined: 'Поле stages не указано',
  failedToSave:
    'Не удалось сохранить, проверьте правильность формата конфигурации',
  workflowDefaultName: 'Процесс',
  nextStageAction: 'Следующий этап',
  create: 'Создать задачу',
  errorInLine: (lineNum: number) => `Ошибка в строке ${lineNum}`
}
